module.exports = __webpack_public_path__ + "media/case4_mob.e50c2076.mp4";